import React from "react";
import { CustomHeading, HeadingContainer, Subtitle, TitleContainer } from "@pages/style";
import RandomEmptyState from "@components/EmptyState/RandomEmptyState/RandomEmptyState";
import { newsImages, newsTexts } from "./InfoRandomHelper";

const NewsPage = () => {
  return (
    <div>
      <HeadingContainer>
        <TitleContainer>
          <CustomHeading noMargin>Suas novidades</CustomHeading>
          <Subtitle color="gray" size="lg" noMargin>
            Confira todas as atualizações relacionadas aos processos e casos desde o seu último
            acesso.
          </Subtitle>
        </TitleContainer>
      </HeadingContainer>

      <RandomEmptyState images={newsImages} texts={newsTexts} />
    </div>
  );
};

export default NewsPage;
